import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {UrlsResources} from "../urls-resources";

@Injectable()
export class ModuleRiskService {
  constructor(private httpClient: HttpClient,
              private urlsResources: UrlsResources) {

  }


  getLimitPurchaseUserWhiteList(): Observable<any> {
    return this.httpClient.get(this.urlsResources.getLimitPurchaseUserWhiteListUrl(), {withCredentials: true});
  }

  updateLimitPurchaseUserWhiteList(updateObject): Observable<any> {
    console.log('Actualizando monto.', updateObject);
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.httpClient.post(this.urlsResources.updateLimitPurchaseUserWhiteListUrl(), updateObject, {
      withCredentials: true,
      headers
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/risk-module/module-risk.service.ts